var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import padding from "@irati/ui/src/global/padding";
import { error } from "@irati/ui/src/global/colors";
import { H4 } from "@irati/ui/src/Headings";
export var Columns = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  overflow: visible;\n  margin-top: ", ";\n"], ["\n  display: flex;\n  overflow: visible;\n  margin-top: ", ";\n"])), padding.base);
export var Error = styled(H4)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), error);
export var TableContainer = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  text-align: ", ";\n"], ["\n  text-align: ", ";\n"])), function (_a) {
    var alignLeft = _a.alignLeft;
    return alignLeft ? "left" : "center";
});
var templateObject_1, templateObject_2, templateObject_3;
